import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Witch extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="60.609" cy="115.32874" />
				<ellipse fill="#4C4C4C" cx="60.609" cy="109.32769" rx="60.2445" ry="14.21944" />
				<path fill="#515151" d="M60.609,109.57452c27.10395,0,33.88211-5.43649,33.88211-5.43649L64.7455,3.31687
					c-1.30478-4.42249-6.96821-4.42249-8.27299,0L26.72689,104.13803C26.72689,104.13803,33.50505,109.57452,60.609,109.57452z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Witch.js